import React from 'react'
import BannerTitles from "../../molecules/bannerTitles/bannerTitles";
import ParticipationSteps from "../../molecules/participationSteps/participationSteps";
import Inspired from "../../molecules/inspired/inspired";
import AmbassadorCharacteristics from "../../molecules/ambassadorCharacteristics/ambassadorCharacteristics";

const ContentBeAnAmbassador = () => {
  return (
    <>
      <BannerTitles section='ambassador'/>
      <AmbassadorCharacteristics/>
      <ParticipationSteps/>
      <Inspired/>
    </>
  )
}

export default ContentBeAnAmbassador
